/* eslint-disable @typescript-eslint/no-explicit-any */
import { v4 as uuidv4 } from 'uuid';

export interface DomainEvent {
    readonly eventId: string;
    readonly eventType: string;
    readonly timestamp: Date;
    readonly version: number;
    readonly aggregateId: string;
    readonly data: Record<string, any>;
}

export abstract class BaseDomainEvent implements DomainEvent {
    public readonly eventId: string;
    public readonly timestamp: Date;
    public readonly version: number = 1;

    constructor(
        public readonly eventType: string,
        public readonly aggregateId: string,
        public readonly data: Record<string, any> = {} // TODO: any should not be used
    ) {
        this.eventId = uuidv4();
        this.timestamp = new Date();
    }
}
